import { render, staticRenderFns } from "./add-indicadores.vue?vue&type=template&id=1408a8cc&"
import script from "./add-indicadores.vue?vue&type=script&lang=js&"
export * from "./add-indicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports